import Cookies from 'js-cookie';

const COOKIE_DOMAIN = '.gbase.ai';

interface StorageOptions {
  key: string;
  value: string;
  days?: number;
  syncToStorage?: boolean;
}

// 设置cookie
function setCookie(name: string, value: string, days: number = 365) {
  try {
    Cookies.set(name, value, {
      domain: COOKIE_DOMAIN,
      path: '/',
      expires: days,
    });
    return true;
  } catch (e) {
    console.error('setCookie error', e);
    return false;
  }
}

// 检查存储是否可用
function isStorageAvailable(type: 'localStorage' | 'sessionStorage'): boolean {
  try {
    const storage = window[type];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}

// 从所有存储中获取值
export function getStorageValue(key: string): string | null {
  // 1. 尝试从cookie获取（主要存储）
  const cookieValue = Cookies.get(key);
  console.log('getStorageValue', key, cookieValue);
  if (cookieValue) {
    // 同步到localStorage作为备份
    if (isStorageAvailable('localStorage')) {
      try {
        localStorage.setItem(key, cookieValue);
      } catch (e) {
        // 忽略错误
      }
    }
    return cookieValue;
  }

  // 2. 尝试从localStorage获取（cookie过期后的备份）
  if (isStorageAvailable('localStorage')) {
    try {
      const localValue = localStorage.getItem(key);
      if (localValue) {
        // 同步到cookie
        setCookie(key, localValue);
        return localValue;
      }
    } catch (e) {
      // 忽略错误
    }
  }

  // 3. 尝试从sessionStorage获取（无痕模式）
  if (isStorageAvailable('sessionStorage')) {
    try {
      const sessionValue = sessionStorage.getItem(key);
      if (sessionValue) return sessionValue;
    } catch (e) {
      // 忽略错误
    }
  }

  return null;
}

// 保存值到所有可用的存储中
export function setStorageValue({ key, value, days = 365, syncToStorage = true }: StorageOptions): void {
  console.log('setStorageValue', key, value, days, syncToStorage);
  // 1. 保存到cookie（主要存储）
  setCookie(key, value, days);

  if (syncToStorage) {
    // 2. 保存到localStorage（作为备份）
    if (isStorageAvailable('localStorage')) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        // 忽略错误
      }
    }

    // 3. 保存到sessionStorage（无痕模式）
    if (isStorageAvailable('sessionStorage')) {
      try {
        sessionStorage.setItem(key, value);
      } catch (e) {
        // 忽略错误
      }
    }
  }
}

// 从所有存储中删除值
export function removeStorageValue(key: string): void {
  // 1. 删除cookie
  Cookies.remove(key, { domain: COOKIE_DOMAIN, path: '/' });

  // 2. 删除localStorage
  if (isStorageAvailable('localStorage')) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      // 忽略错误
    }
  }

  // 3. 删除sessionStorage
  if (isStorageAvailable('sessionStorage')) {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      // 忽略错误
    }
  }
}
